import { DATE_ONLY_FORMAT, toDateOnlyString, toExclusiveDate } from '@urbanx/agx.ui-components2';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

const getBrowserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

const parseAutomationFailureInstant = (instant: string) => {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/.test(instant)) {
    throw new Error('Expected an ISO-8601 UTC instant');
  }

  const parsedInstant = dayjs.utc(instant);
  if (!parsedInstant.isValid()) {
    throw new Error('Expected an ISO-8601 UTC instant');
  }

  return parsedInstant;
};

export const toAutomationFailureBrowserDate = (instant: string) =>
  parseAutomationFailureInstant(instant).tz(getBrowserTimeZone()).format(DATE_ONLY_FORMAT);

export const formatAutomationFailureInstant = (instant?: string) =>
  instant
    ? parseAutomationFailureInstant(instant).tz(getBrowserTimeZone()).format('D MMM YYYY, h:mm a')
    : 'Not recorded';

export const formatAutomationFailureRelativeInstant = (instant: string) =>
  parseAutomationFailureInstant(instant).fromNow();

export const formatAutomationFailureShortInstant = (instant: string) => {
  const browserTimeZone = getBrowserTimeZone();
  const occurred = parseAutomationFailureInstant(instant).tz(browserTimeZone);
  const now = dayjs().tz(browserTimeZone);

  return occurred.isSame(now, 'day') ? occurred.format('h:mm a') : occurred.format('D MMM, h:mm a');
};

export const toAutomationFailureStartOfBrowserDayInstant = (date: string) => {
  toDateOnlyString(date);

  return dayjs.tz(date, DATE_ONLY_FORMAT, getBrowserTimeZone()).startOf('day').utc().toISOString();
};

export const toAutomationFailureNextStartOfBrowserDayInstant = (date: string) =>
  toAutomationFailureStartOfBrowserDayInstant(toExclusiveDate(date));
